import React, { useState } from "react";
import LabelInput from "../../common/LabelInput";
import Body from "../../components/Body";
import { cloneDeep } from "lodash";
import config from "../../config/config";
import { grey } from "@mui/material/colors";
import AppButton from "../../common/AppButton";
import AppSelect from "../../common/AppSelect";
import DetailBlock from "../../common/DetailBlock";
import numberOnly from "../../common/numberOnly";
import api from "../../config/api";
import CheckBox from "../../common/CheckBox";
import { FaUserTie } from "react-icons/fa";
import { RiPhoneFill } from "react-icons/ri";
import { IoLocationSharp } from "react-icons/io5";
import { BiCheckCircle } from "react-icons/bi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const formInit = {
  employeeId: "",
  name: "",
  contact: "",
  type: "",
  startTime: "08:00",
  endTime: "17:00",
  availability: [],
};
const focusInit = {
  type: false,
  availability: false,
};
const size = config.iconSize;

export default function EmployeeCreate() {
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();
  const [form, setForm] = useState(cloneDeep(formInit));
  const [focused, setFocused] = useState(focusInit);
  const queryClient = useQueryClient();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const found = ["type"].filter((i) => {
      if (form[i].length === 0) {
        setFocused({ ...focused, [i]: Math.random() });
        return i;
      }
      return false;
    });
    if (found.length !== 0) return false;

    if (form.availability.length === 0) {
      return toast.warning("Please select availability days");
    }

    setDisabled(true);
    const res = await api.post("employees", form);
    if (!res.ok) {
      setDisabled(false);
      return toast.error(res.originalError.message);
    }
    queryClient.invalidateQueries(["employees"]);

    setDisabled(false);
    toast.success("Employee has been successfully created.");
    navigate(-1);
  };
  const handleChange = ({ currentTarget }) => {
    const name = currentTarget.name;
    const value = currentTarget.value;
    setForm({ ...form, [name]: value });
  };
  const handleCheck = (value) => {
    const found = form.availability.find((i) => i.title === value);

    if (!found) {
      setForm({
        ...form,
        availability: [...form.availability, { title: value }],
      });
    } else {
      setForm({
        ...form,
        availability: form.availability.filter((i) => i.title !== value),
      });
    }
  };
  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  return (
    <Body back title="Create ">
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <DetailBlock style={{ padding: 40, width: 900 }}>
            <div
              className="d-flex "
              style={{ gap: 40, alignItems: "flex-end" }}
            >
              <LabelInput
                onChange={handleChange}
                leftIcon={<FaUserTie size={size} color={grey[500]} />}
                placeholder="Name"
                name="name"
                value={form.name}
                required
              />
              <LabelInput
                leftIcon={<RiPhoneFill size={size} color={grey[500]} />}
                placeholder="Contact"
                onChange={handleChange}
                name="contact"
                type="tel"
                value={numberOnly(form.contact)}
                required
              />
              <AppSelect
                onChange={handleChange}
                leftIcon={<IoLocationSharp size={size} color={grey[500]} />}
                focused={focused.type}
                required
                placeholder="Type"
                name="type"
                options={["Casual", "Regular", "Subcontractor"]}
                value={form.type}
                style={{ height: 65 }}
              />
            </div>
          </DetailBlock>
          <DetailBlock style={{ padding: 40, width: 900 }}>
            <div className="d-flex " style={{ gap: 40 }}>
              <div>
                <span>Availability</span>
                <div className="d-flex" style={{ gap: 5 }}>
                  {days.map((dt, ind) => {
                    return (
                      <CheckBox
                        onClick={handleCheck}
                        key={String(ind)}
                        text={dt.slice(0, 2)}
                        value={dt}
                      />
                    );
                  })}
                </div>
              </div>

              <LabelInput
                onChange={handleChange}
                label="From"
                forceLabel="From"
                name="startTime"
                value={form.startTime}
                timePicker
                minTime="06:00"
                required
              />
              <LabelInput
                forceLabel="To"
                label="To"
                onChange={handleChange}
                name="endTime"
                value={form.endTime}
                timePicker
                minTime="06:00"
                required
              />
            </div>
          </DetailBlock>
          <AppButton
            disabled={disabled}
            style={{ margin: "10px 0px" }}
            type="submit"
            leftIcon={<BiCheckCircle size={20} />}
            text="Create"
            className="btn-primary"
          />
        </div>
      </form>
    </Body>
  );
}
